export const EXTERNAL_LINKS = {
  JOIN_AGILEENGINE: 'https://join.agileengine.com/',
  WHY_US: 'https://join.agileengine.com/why-us/',
  REFER_A_FRIEND: 'https://join.agileengine.com/refer-a-friend/',
  OPEN_POSITIONS: 'https://join.agileengine.com/open-positions/',
};
